import { migrateLegacySettingsBookmark } from '../features/settings/settingsNavigation';

/** Page removals are global; account permissions must never prune user preferences. */
export function isRetiredBookmark(href: string): boolean {
  const pathname = href.split(/[?#]/, 1)[0].replace(/\/+$/, '');
  return pathname === '/restock/opportunities'
    || pathname === '/workflows/builder'
    || pathname === '/workflows/draft-shipments/new'
    || pathname === '/workflows/labels';
}

export function migrateWorkflowBookmarkHref(href: string): string {
  const match = /^([^?#]*)(.*)$/.exec(href);
  const pathname = match?.[1] ?? href;
  const suffix = match?.[2] ?? '';

  if (pathname === '/workflows/builder') {
    return `/workflows/draft-shipments/new${suffix}`;
  }
  if (pathname === '/workflows/master') {
    return `/workflows/working-shipments${suffix}`;
  }
  if (pathname === '/shipping/outbound') {
    return `/workflows/shipped/freight${suffix}`;
  }
  if (pathname.startsWith('/shipping/outbound/')) {
    return `/workflows/shipped/freight/${pathname.slice('/shipping/outbound/'.length)}${suffix}`;
  }

  // Settings moved from one page into Account, Operations, and Store areas.
  const settingsHref = migrateLegacySettingsBookmark(pathname, suffix);
  if (settingsHref) return settingsHref;

  const legacyShippedPlan = /^\/workflows\/shipped\/([^/]+)$/.exec(pathname);
  if (
    legacyShippedPlan
    && legacyShippedPlan[1] !== 'fba'
    && legacyShippedPlan[1] !== 'freight'
  ) {
    return `/workflows/shipped/fba/plan/${legacyShippedPlan[1]}${suffix}`;
  }

  // Master child bookmarks remain on their compatibility loader because their
  // final stage must be resolved from live child state before choosing Working
  // or Shipped. The loader preserves the requested child and query/hash.
  return href;
}

export function normalizeBookmarkedPages(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const seen = new Set<string>();
  const bookmarkedPages: string[] = [];

  for (const href of value) {
    if (typeof href !== 'string') continue;
    const normalizedHref = migrateWorkflowBookmarkHref(href.trim());
    if (
      isRetiredBookmark(normalizedHref)
      || !normalizedHref.startsWith('/')
      || normalizedHref.startsWith('//')
      || /\s/.test(normalizedHref)
      || seen.has(normalizedHref)
    ) {
      continue;
    }

    seen.add(normalizedHref);
    bookmarkedPages.push(normalizedHref);
  }

  return bookmarkedPages;
}

